import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ContentService } from '../../../../content/services/content.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-forbidden-dialog',
  templateUrl: './forbidden-dialog.component.html',
  standalone: false
})
export class ForbiddenDialogComponent{

  phoneNumber$: Observable<string>;

  constructor(
    private contentService: ContentService,
    public dialogRef: MatDialogRef<ForbiddenDialogComponent>,
  ) {
    this.phoneNumber$ = this.contentService.getHelpDeskNumber();
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
